export default __webpack_public_path__ + "static/media/27_CPC.49db989c.png";